module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAiCAYAAAAkjjtxAAAAAXNSR0IArs4c6QAAATRJREFUWAnV2EsOwiAQANDCXdyX9gbudOEBdGc8g5fwCqYrr2DceoF+LtQgU0vSJczQGUrSsGE6DzqhhKLYWFMcXmutGobhALnKsvwopSw2r8YGxsQBdhzHNzxd1z1hAjHxy7Es4GVCh71S0CzguQwaD6eg0Z/GJw/toQzmlb36GFfLTVVVt5iaZgMDMgWaFZwCzQ6mokXAFLQYGIsWBWPQ4uBYdBbgGHQ24FD0BJ439LML2kGgdHOekzMY79Baf40xe/gjTuC2bS9u0MsPyLF32Edd13eWw0/KBdhmSaRcAcq7Qg5H2ewSIVhYjCzAodgswDFYcXAsVhSMwYqBsVgRMAXLDqZiWcEpsGzgVFg2cN/3R7hXg4TQMBco/8iiYD+tUbDTZL18zR5KItV165rOVd79A7g0XJW8yHORAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/common/images/right_gray.png
// module id = 923
// module chunks = 1